<template>
   <div class="modal-dialog  modal-fullscreen">
        <div class="modal-content"  >
            <div class="modal-header bg-primary">
                <h2 class="modal-title text-white fw-bolder col-md-10">
                     {{ $t('parameters_template') }} 
                </h2>  
                <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closeParametersModal"
                    @click="this.$parent.isShow.ParameterModal = false;">
                    <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                        </svg>
                    </span>
                </div>
            </div>
            <div class="modal-body">
                <div class="content flex-row-fluid mt-4" id="kt_content">
                    <div class="card card-xxl-stretch" v-if="modalType == null || modalType == undefined || modalType == ''">
                        <div class="p-5">
                            <div class="card-header">
                                <div class="card-title">
                                    <div>
                                        <h3> {{this.selectedTemplate.name }} </h3>
                                        <small>{{this.selectedTemplate.description}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="d-flex flex-stack flex-wrap mb-5">
                                    <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                                        <button type="button" class="btn btn-sm btn-light btn-active-success me-3" ref="btnAddItem" @click="this.openForm('add')">
                                            <span class="svg-icon svg-icon-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none">
                                                    <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                                        transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                                    <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                                        fill="currentColor">
                                                    </rect>
                                                </svg>
                                            </span>
                                             {{ $t('add_new') }} 
                                        </button>
                                        <button type="button" class="btn btn-sm btn-light btn-active-primary me-3" @click="this.openForm('edit')"
                                            :disabled="isButtonDisabled == null || isButtonDisabled == undefined">
                                            <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                                                    </svg>
                                            </span>
                                             {{ $t('edit') }} 
                                        </button>
                                        <button type="button" class="btn btn-sm btn-light btn-active-warning me-3" @click="this.deleteItem()" 
                                            :disabled="isButtonDisabled == null || isButtonDisabled == undefined">
                                            <span class="svg-icon svg-icon-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                </svg>
                                            </span>
                                             {{ $t('remove') }} 
                                        </button>
                                        <button type="button" class="btn btn-sm btn btn-light btn-active-danger me-3" @click="this.deleteItem(true)" 
                                            :disabled="this.parameterList.length == 0">
                                            <span class="svg-icon svg-icon-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                </svg>
                                            </span>
                                             {{ $t('remove_all') }} 
                                        </button>
                                    </div>
                                </div>
                                <div id="kt_datatable_example_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div class="table-responsive">
                                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                                            key-expr="id" 
                                            :data-source="parameterList" 
                                            :allow-column-reordering="true"  
                                            :allow-column-resizing="true" 
                                            :column-auto-width="true" 
                                            :row-alternatin-enabled="true"
                                            :hover-state-enabled="true" 
                                            :show-row-lines="true" >                            
                                            <DxFilterRow :visible="true"/>
                                            <DxHeaderFilter :visible="true"/>
                                            <DxGroupPanel :visible="true"/>   
                                            <DxColumn data-field="isSelected" caption="#" :width="100" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template" :allow-exporting="false"/>
                                            <DxColumn data-field="column_name" caption="Column Name" alignment="left" cell-template="column_name-cell-template" />
                                            <DxColumn data-field="column_value" caption="Column Parameter" alignment="left" />
                                            <DxColumn data-field="parameter_name" caption="Parameter Name" alignment="left" />                                           
                                            <template #is-selected-cell-template="{ data }"> 
                                                <span>
                                                    <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                                        <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectItem(data.data)" />
                                                    </div>
                                                </span>
                                            </template>
                                            <template #column_name-cell-template="{ data }"> 
                                                <span>
                                                    {{getColumnName(data.data.column_name)}}
                                                </span>
                                            </template>
                                        </DxDataGrid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    <div class="card card-xxl-stretch" v-if="modalType !== null && modalType !== undefined && modalType !== ''">
                        <div class="card-header">
                            <div class="card-title">
                                <h3 v-if="modalType == 'add'">{{$t('add_new_parameter')}}</h3>
                                <h3 v-if="modalType == 'edit'">{{$t('edit_parameter')}}</h3>
                            </div>
                        </div>
                        <div class="card-body py-3">
                            <div id="kt_policy_tab_1" class="tab-pane fade show active" role="tabpanel">
                                <div class="fv-row row mb-7">
                                    <div class="col-lg-12">
                                        <label class="fs-6 fw-bold form-label mt-3">{{ $t('template_column_name') }}</label>
                                        <Select2 v-model="form.column_name" :options="this.templateColumns" :settings="{ width: '100%' }" />
                                    </div>
                                    <div class="col-lg-12">
                                        <label class="fs-6 fw-bold form-label mt-3">{{ $t('template_column_value') }}</label>
                                        <input type="text" class="form-control" name="column_value" v-model="form.column_value">
                                    </div>
                                    <div class="col-lg-12">
                                        <label class="fs-6 fw-bold form-label mt-3">{{ $t('template_parameter') }}</label>
                                        <Select2 v-model="form.parameter_value" :options="this.parameterTypeList" @select="onSelected($event)" :settings="{ width: '100%' }" />
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="d-grid gap-2">
                                        <button type="button" class="btn btn-success btn-lg" v-if=" modalType == 'add'"
                                            @click="saveData()">
                                            <span class="indicator-label">{{$t('save')}}</span> 
                                        </button>
                                        <button type="button" class="btn btn-primary btn-lg" v-if="modalType == 'edit'"
                                            @click="updateData()">
                                            <span class="indicator-label">{{$t('update')}}</span> 
                                        </button>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="d-grid gap-2">
                                        <button type="button" class="btn btn-light border border-gray-300 btn-lg float-end" @click="clearForm()">
                                            <span class="indicator-label">{{$t('cancel')}}</span> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxColumn } from 'devextreme-vue/data-grid'; 
    export default {
    name: "DataImportParametersModal",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxColumn
    },
    data() {
        return {
            selectedTemplate: {},
            form: {
                column_name: '-1',
                column_value: null,
                parameter_value: 0,
                parameter_name: null,
            },
            templateColumns: [
                {id: '-1', text: this.$t('select_an_option')},
                {id: 'transaction_in_out', text: this.$t('transaction_inout')},
            ],
            parameterList: [],
            parameterTypeList: [
                {id: 0, text: this.$t('select_an_option')},
                {id: 1, text: this.$t('incoming')},
                {id: 2, text: this.$t('outgoing')}
            ],
            modalType: null,
        };
    },
    computed: {    
        isButtonDisabled() {
            return this.parameterList.find(item => item.isSelected == true ); 
        },
        getColumnName() {
            return (value)=>{
                if (value) {
                    return this.templateColumns.find(p => { 
                        return p.id == value;
                    }).text; 
                }
            } 
        }
    },
    methods: {
        getData(){
            const parameters = {
                session_id: this.$getUser().session_id,
                template_id: this.$getSessionStorage('template_record_id'),
                id: this.$getSessionStorage('template_record_id')
            };
            const requestOne =  axios.post('/api/DataImport/GetParameters', parameters, {'Content-Type': 'application/json'});
            const requestTwo =  axios.post('/api/DataImport/GetDataImportTemplateById', parameters, {'Content-Type': 'application/json'});
            axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
                this.parameterList = responses[0].data;
                this.selectedTemplate = responses[1].data;
            }))
            .catch(errors => { 
                console.error(errors); 
            });
        },    
        openForm(modalType) {
            this.clearForm();
            this.modalType = modalType;
            if(modalType == 'edit') {
                this.parameterList.forEach(element => {
                    if(element.isSelected) {
                        this.form.id = element.id;
                        this.form.column_name = element.column_name;
                        this.form.column_value = element.column_value;
                        this.form.parameter_value = element.parameter_value;
                        this.form.parameter_name = element.parameter_name;
                    }
                });
            }
        },
        onSelectItem(item) {
            this.parameterList.forEach((value) => { 
                if (item.id !== value.id) {
                    value.isSelected = false;
                }
            });
        },
        deleteItem(isDeleteAll){
            let detailId = null;
            this.parameterList.forEach((item) => {
                if (item.isSelected) {
                    detailId = item.id;
                }
            });
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_remove_this_item'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('delete'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const parameters = {
                        session_id: this.$getUser().session_id,
                        template_id: this.$getSessionStorage('template_record_id'),
                        is_delete_all: isDeleteAll ? 1 : 0,
                        id: detailId,
                    }; 
                    axios.post('/api/DataImport/DeleteParameter', parameters, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == '' || response.data.error == undefined){
                            this.getData();
                        } 
                    }) 
                    .catch((error) => {
                        console.error(error);
                        this.Progress.finish();
                    });
                }
            });
        },
        saveData() {
            if(this.form.column_name == '-1' || this.form.column_name == null || this.form.column_name == '') {
                this.$swal(this.$t('warning'), this.$t('column_name_can_not_be_empty'), 'info');  
            }
            if(this.form.parameter_value == 0 || this.form.parameter_value == null || this.form.parameter_value == '') {
                this.$swal(this.$t('warning'), this.$t('parameter_value_can_not_be_empty'), 'info');  
            }
            const params = {
                session_id: this.$getUser().session_id,
                template_id: this.$getSessionStorage('template_record_id'),
                column_name: this.form.column_name,
                column_value: this.form.column_value,
                parameter_value: this.form.parameter_value,
                parameter_name: this.form.parameter_name,
            };
            axios.post('api/DataImport/CreateParameter',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
                    this.parameterList = response.data;
                    this.modalType = null;
                    this.clearForm();
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        updateData() {
            if(this.form.column_name == '-1' || this.form.column_name == null || this.form.column_name == '') {
                this.$swal(this.$t('warning'), this.$t('column_name_can_not_be_empty'), 'info');  
            }
            if(this.form.parameter_value == 0 || this.form.parameter_value == null || this.form.parameter_value == '') {
                this.$swal(this.$t('warning'), this.$t('parameter_value_can_not_be_empty'), 'info');  
            }
            const params = {
                session_id : this.$getUser().session_id,
                template_id: this.$getSessionStorage('template_record_id'),
                id: this.form.id,
                column_name: this.form.column_name,
                column_value: this.form.column_value,
                parameter_value: this.form.parameter_value,
                parameter_name: this.form.parameter_name,
            };
            axios.post('api/DataImport/UpdateParameter',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_update_succesfully'), 'success');  
                    this.parameterList = response.data;
                    this.modalType = null;
                    this.clearForm();
                }
            })
            .catch((error) => {
                console.error(error);
            });        
        },
        clearForm() {
            this.form = {
                id: null,
                column_name: '-1',
                column_value: null,
                parameter_value: 0,
                parameter_name: null,
            };
            this.modalType = null;
        },
        onSelected(event) {
            this.form.parameter_name = event.id !== '-1' ? event.text : null;
        }
    }
}; 
</script>